
//frontend/src/components/WarehousesPage/WarehousesPage.jsx
  import React, { useEffect, useState } from "react";
  import Button from "../UI/Button";
  import Card from "../UI/Card";
  import Modal from "../UI/Modal";
  import ConfirmModal from "../UI/ConfirmModal";
  import { authFetch } from "../api/api";
  import { useParams } from "react-router-dom";
  import { useTranslation } from "react-i18next";

  



  const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

  const WAREHOUSES_URL = `${BASE_URL}/api/warehouses/`;
  const EXPEDITORS_URL = `${BASE_URL}/api/expeditors/`;
  const CITIES_URL = `${BASE_URL}/api/cities/`;

  const initialFormData = {
    name: "",
    expeditor: "",      // ID экспедитора
    address_cn: "",
    city: "",           // ID города
    recipient_name: "",  // обязательно
    recipient_phone: "",
    comment: "",
    country: "CN",
    zip_code: "",
  };

  const WarehousesPage = () => {
    const [warehouses, setWarehouses] = useState([]);
    const [expeditors, setExpeditors] = useState([]);
    const [cities, setCities] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState(initialFormData);
    const [editingId, setEditingId] = useState(null);
    const [deleteId, setDeleteId] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const { id: expeditorId } = useParams();
    const { t } = useTranslation("ExpeditorsPage");
    const expeditorName = expeditors.find(
        (e) => Number(e.id) === Number(expeditorId)
    )?.name;


    // --- Загрузка данных ---
    const fetchWarehouses = async () => {
    setLoading(true);
    try {
        const res = await authFetch(WAREHOUSES_URL);
        const data = await res.json();
        const filtered = data.filter(
        (w) => Number(w.expeditor) === Number(expeditorId)
        );
        setWarehouses(filtered);
    } catch (err) {
        console.error("Ошибка загрузки складов:", err);
    } finally {
        setLoading(false);
    }

    };

    const fetchExpeditors = async () => {
      try {
        const res = await authFetch(EXPEDITORS_URL);
        const data = await res.json();
        setExpeditors(data);
      } catch (err) {
        console.error("Ошибка загрузки экспедиторов:", err);
      }
    };

    const fetchCities = async () => {
      try {
        const res = await authFetch(CITIES_URL);
        const data = await res.json();
        setCities(data);
      } catch (err) {
        console.error("Ошибка загрузки городов:", err);
      }
    };

    useEffect(() => {
      fetchWarehouses();
      fetchExpeditors();
      fetchCities();
    }, []);

    // --- Добавление/редактирование ---
    const handleAdd = () => {
    setFormData({
        ...initialFormData,
        expeditor: expeditorId, // 👈 ВАЖНО: фиксируем текущего экспедитора
    });
    setEditingId(null);
    setShowModal(true);
    };

    const handleEdit = (w) => {
      setFormData({
        name: w.name || "",
        expeditor: w.expeditor || "",
        address_cn: w.address_cn || "",
        city: w.city || "",
        recipient_name: w.recipient_name || "",
        recipient_phone: w.recipient_phone || "",
        comment: w.comment || "",
        country: w.country || "CN",
        zip_code: w.zip_code || "",
      });
      setEditingId(w.id);
      setShowModal(true);
    };

    const handleSubmit = async (e) => {
      e.preventDefault();

      // Проверка обязательных полей
      if (!formData.name || !formData.recipient_name) {
        alert("Пожалуйста, заполните все обязательные поля: имя склада, экспедитор, получатель");
        return;
      }

      const method = editingId ? "PUT" : "POST";
      const url = editingId ? `${WAREHOUSES_URL}${editingId}/` : WAREHOUSES_URL;

      // payload для бэкенда
      const payload = {
        ...formData,
        expeditor: Number(formData.expeditor),
        city: formData.city ? Number(formData.city) : null,
      };

      try {
        const res = await authFetch(url, {
          method,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          const errData = await res.json();
          console.error("Ошибка от сервера:", errData);
          alert(`Ошибка при сохранении: ${JSON.stringify(errData)}`);
          return;
        }

        setShowModal(false);
        setFormData(initialFormData);
        setEditingId(null);
        fetchWarehouses();
      } catch (err) {
        console.error(err);
        alert("Ошибка при сохранении данных");
      }
    };

    const handleDelete = async () => {
      if (!deleteId) return;

      try {
        const res = await authFetch(`${WAREHOUSES_URL}${deleteId}/`, {
          method: "DELETE",
        });

        if (!res.ok) throw new Error("Ошибка при удалении");

        setShowDeleteModal(false);
        setDeleteId(null);
        fetchWarehouses();
      } catch (err) {
        console.error(err);
        alert("Ошибка при удалении");
      }
    };

    if (loading) return <div className="p-4">{t("warehouse_loading")}</div>;

    return (
      <div className="p-4">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-xl font-bold">{t("warehouses")} {expeditorName}</h1>
          <Button variant="primary" onClick={handleAdd}>
            {t("add_new_warehouse")}
          </Button>
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-200 rounded-lg">
            <thead>
              <tr className="bg-gray-100 text-left">
                <th className="py-2 px-4 border-b">{t("warehouse_name")}</th>
                <th className="py-2 px-4 border-b">{t("address")}</th>
                <th className="py-2 px-4 border-b">{t("city")}</th>
                <th className="py-2 px-4 border-b">{t("recipient")}</th>
                <th className="py-2 px-4 border-b">{t("phone")}</th>
                <th className="py-2 px-4 border-b">{t("comment")}</th>
                <th className="py-2 px-4 border-b">{t("actions")}</th>
              </tr>
            </thead>
            <tbody>
              {warehouses.map((w) => (
                <tr key={w.id} className="hover:bg-gray-50">
                  <td className="py-2 px-4 border-b">{w.name}</td>
                  <td className="py-2 px-4 border-b">{w.address_cn}</td>
                  <td className="py-2 px-4 border-b">{w.city_name}</td>
                  <td className="py-2 px-4 border-b">{w.recipient_name}</td>
                  <td className="py-2 px-4 border-b">{w.recipient_phone}</td>
                  <td className="py-2 px-4 border-b">{w.comment}</td>
                  <td className="py-2 px-4 border-b flex gap-2">
                  <Button variant="edit" onClick={() => handleEdit(w)}>
                    {t("edit")}
                  </Button>
                    <Button
                      variant="danger"
                      onClick={() => {
                        setDeleteId(w.id);
                        setShowDeleteModal(true);
                      }}
                    >
                      {t("delete")}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Модалка */}
        {showModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
            <form
              onSubmit={handleSubmit}
              className="bg-white rounded-2xl p-6 w-[400px] shadow-2xl space-y-4"
            >
              <h3 className="text-lg font-semibold text-center">
                {editingId ? t("edit_warehouse") : t("add_warehouse")}
              </h3>

              <div>
                <label className="block text-sm font-medium mb-1">{t("warehouse_name")} *</label>
                <input
                  type="text"
                  value={formData.name || ""}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="w-full border rounded-md px-3 py-2"
                  required
                />
              </div>


              <div>
                <label className="block text-sm font-medium mb-1">{t("city")}</label>
                <select
                  value={formData.city || ""}
                  onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                  className="w-full border rounded-md px-3 py-2"
                >
                  <option value="">{t("select_city")}</option>
                  {cities.map((c) => (
                    <option key={c.id} value={c.id}>{c.name}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">{t("address")}</label>
                <input
                  type="text"
                  value={formData.address_cn || ""}
                  onChange={(e) => setFormData({ ...formData, address_cn: e.target.value })}
                  className="w-full border rounded-md px-3 py-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">{t("recipient")} *</label>
                <input
                  type="text"
                  value={formData.recipient_name || ""}
                  onChange={(e) => setFormData({ ...formData, recipient_name: e.target.value })}
                  className="w-full border rounded-md px-3 py-2"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">{t("phone")}</label>
                <input
                  type="text"
                  value={formData.recipient_phone || ""}
                  onChange={(e) => setFormData({ ...formData, recipient_phone: e.target.value })}
                  className="w-full border rounded-md px-3 py-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">{t("comment")}</label>
                <textarea
                  value={formData.comment || ""}
                  onChange={(e) => setFormData({ ...formData, comment: e.target.value })}
                  className="w-full border rounded-md px-3 py-2"
                />
              </div>

              <div className="flex justify-between">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                >
                  {t("cancel")}
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  {t("save")}
                </button>
              </div>
            </form>
          </div>
        )}
    <ConfirmModal
      isOpen={showDeleteModal}
      onClose={() => {
        setShowDeleteModal(false);
        setDeleteId(null);
      }}
      onConfirm={handleDelete}
      title={t("delete_title")}
      description={t("delete_description")}
      confirmText={t("delete")}
    />
        
      </div>
    );
  };

  export default WarehousesPage;